var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoverage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 74,
  height: 91,
  fill: "none",
  viewBox: "0 0 74 91"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4DC29F",
  fillRule: "evenodd",
  d: "m37.822 0 32.89 8.222C72.766 8.633 74 10.278 74 12.333v32.89c0 26.721-33.711 43.988-35.356 44.81-.41.411-.822.411-1.644.411s-1.233 0-1.644-.41C33.71 89.21 0 71.943 0 45.221V12.333c0-2.055 1.233-3.7 2.878-4.11L35.767 0z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A876",
  d: "M67.833 45.44c0 19.638-23.785 34.474-30.833 38.838-7.048-3.927-30.833-18.764-30.833-38.837V14.02L37 6.168l30.833 7.855z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M56.487 32.472 35.238 54.486c-.712.676-1.424 1.014-2.493 1.014s-1.78-.338-2.493-1.014L19.568 44.339c-1.424-1.353-1.424-3.382 0-4.735 1.425-1.353 3.562-1.353 4.986 0l8.191 7.78 18.756-19.647c1.425-1.353 3.562-1.353 4.986 0 1.425 1.353 1.425 3.383 0 4.735"
})));
export default SvgCoverage;